"use client";

import { createContext, useContext } from "react";

export const CartTabsContext = createContext<{
  tab: "cart" | "wishlist";
  setTab: (tab: "cart" | "wishlist") => void;
} | null>(null);

export const CartTabsProvider = CartTabsContext.Provider;

export const useCartTabs = () => {
  return useContext(CartTabsContext);
};
